(function ($) {
    const body = document.body;
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";

    let lastScroll = 60;
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 60) {
        body.classList.remove(scrollUp);
        return;
      }

      if (currentScroll <= 140) {
        body.classList.remove(scrollDown);
        return;
      }

      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } 
      else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      lastScroll = currentScroll;
    });

})(jQuery);